import { render, staticRenderFns } from "./userHelp.vue?vue&type=template&id=63b12266&scoped=true&"
import script from "./userHelp.vue?vue&type=script&lang=js&"
export * from "./userHelp.vue?vue&type=script&lang=js&"
import style0 from "./userHelp.vue?vue&type=style&index=0&id=63b12266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b12266",
  null
  
)

export default component.exports